/* eslint-disable @next/next/no-img-element */
"use client";
import React, { useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import useTranslation from "@/hook/useTranslation";
import LanguageSwitcher from "./LanguageSwitcher";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Button } from "./Button";
import { FiMenu } from "react-icons/fi"; // hamburger icon
import SearchBox from "@/components/SearchBox";

export const Header = () => {
  const router = useRouter();
  const { locale, t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const pathname = usePathname();
  const languages = [
    { code: "en", label: "English" },
    { code: "th", label: "ไทย" },
    { code: "zh", label: "中文" },
  ];
  const [query, setQuery] = useState("");

  const handleNavigation = (path) => {
    router.push(path);
    setSidebarOpen(false); // Close sidebar on navigation
  };

  const changeLanguage = (newLocale) => {
    const segments = pathname.split("/");
    segments[1] = newLocale;

    const newPathname = segments.join("/");
    router.push(newPathname);
  };

  const handleSubmit = (keyword) => {
    window.location = `/${locale}/search?query=${encodeURIComponent(keyword)}`;
  };

  return (
    <>
      <div className="header-layout">
        <div className="logo-container">
          <img className="logo" src="/images/logo.jpg" alt="Logo" />
          <h1 className="logo-text">
            <span className="fin">FIN</span>SIGHT
          </h1>
        </div>
        {/* Desktop Menu */}
        <div className="menu desktop-menu">
          <Button type="text" onClick={() => handleNavigation(`/${locale}`)}>
            {t("menuHome")}
          </Button>
          <Button
            type="text"
            onClick={() => handleNavigation(`/${locale}/college`)}
          >
            {t("menuCollege")}
          </Button>

          <Button
            type="text"
            onClick={() => handleNavigation(`/${locale}/news`)}
          >
            {t("menuNews")}
          </Button>
          <Button
            type="text"
            onClick={() => handleNavigation(`/${locale}/activities`)}
          >
            {t("menuActivities")}
          </Button>
          <Button
            type="text"
            onClick={() => handleNavigation(`/${locale}/tools`)}
          >
            {t("menuTools")}
          </Button>
          <Button
            type="text"
            onClick={() => handleNavigation(`/${locale}/contact`)}
          >
            {t("menuContact")}
          </Button>
        </div>
        <div
          style={{
            position: "absolute",
            right: 20,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <SearchBox
            locale={locale}
            defaultValue={query}
            onSearch={(keyword) => handleSubmit(keyword)}
            isSearch
          />
          <LanguageSwitcher />
        </div>
        {/* Hamburger for Mobile */}
        <div
          className="mobile-menu-toggle"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <FiMenu size={24} color="black" />
        </div>
      </div>

      {/* Sidebar for Mobile */}
      {sidebarOpen && (
        <>
          <div className="overlay" onClick={() => setSidebarOpen(false)} />
          <div className={`mobile-sidebar ${sidebarOpen ? "open" : ""}`}>
            <Sidebar
              collapsed={!sidebarOpen}
              toggled={sidebarOpen}
              breakPoint="all"
              onBackdropClick={() => setSidebarOpen(false)}
              backgroundColor="#26c48c"
              menuItemStyles={{
                button: {
                  [`&.ps-active`]: {
                    backgroundColor: "#26c48c", // หรือ transparent หรืออะไรก็ได้
                    color: "#fff",
                  },
                },
              }}
            >
              <Menu style={{ marginTop: "20px" }}>
                <MenuItem onClick={() => handleNavigation(`/${locale}`)}>
                  🏠 {t("menuHome")}
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigation(`/${locale}/college`)}
                >
                  🎓 {t("menuCollege")}
                </MenuItem>
                <MenuItem onClick={() => handleNavigation(`/${locale}/news`)}>
                  📰 {t("menuNews")}
                </MenuItem>
                <MenuItem
                  onClick={() => handleNavigation(`/${locale}/activities`)}
                >
                  🎯 {t("menuActivities")}
                </MenuItem>
                <MenuItem onClick={() => handleNavigation(`/${locale}/tools`)}>
                  🧰 {t("menuTools")}
                </MenuItem>

                <MenuItem
                  onClick={() => handleNavigation(`/${locale}/contact`)}
                >
                  📞 {t("menuContact")}
                </MenuItem>

                <SubMenu label="🌐 Language">
                  {languages.map((lang) => {
                    if (lang.code !== locale) {
                      return (
                        <MenuItem
                          key={lang.code}
                          onClick={() => changeLanguage(lang.code)}
                          active={false}
                        >
                          {lang.label}
                        </MenuItem>
                      );
                    }
                  })}
                </SubMenu>
              </Menu>
            </Sidebar>
          </div>
        </>
      )}
    </>
  );
};
